import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-56" data-mp="16lhc3vi6hayn">
      <div className="mx-auto max-w-5xl" data-id="element-57" data-mp="1bk2bjsplvqm1">
        <div className="flex justify-center" data-id="element-58" data-mp="1bir9pyfq0sxk">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-ivory" data-id="element-59" data-mp="wnbbric0scvw">
            <GiftIcon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-60" data-mp="11lweppinpao1" />
          </span>
        </div>
        <SectionHeading id="bonuses-heading" eyebrow="You Also Get" title="And You’ll Also Get 5 Ready-to-Use Bonuses" className="mt-5" data-id="element-61" data-mp="nneu40o1seac" />

        <div className="mx-auto mt-10 flex max-w-md items-center justify-center gap-3 rounded-[14px] bg-brand-charcoal px-6 py-4" data-id="element-62" data-mp="2hzutqimc8u68">
          <GiftIcon className="h-5 w-5 text-brand-butter" strokeWidth={1.75} aria-hidden="true" data-id="element-63" data-mp="2myz4hdowuzyo" />
          <p className="font-body text-[13px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-64" data-mp="1k6ano346y4sh">
            All 5 Bonuses Included
          </p>
        </div>

        <ol className="mt-10 grid gap-6 md:grid-cols-2" role="list" data-id="element-65" data-mp="1ty6lre6a1uwp">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(70,50,110,0.45)] ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-66" data-mp="1ozlkdbfah56o" data-mpi={index}>
              <div className="px-6 py-3" style={{
            backgroundColor: bonus.accent
          }} data-id="element-67" data-mp="1b7fhus526wpp">
                <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-68" data-mp="168c9oyts8adi">
                  {bonus.number}
                </p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-69" data-mp="2hn7yhdm57s7s">
                <h3 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-70" data-mp="2hmzobthen10a">{bonus.title}</h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-71" data-mp="2pqa101g4swh9">{bonus.description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}